export default function Presentation() {
    return (
        <>
            <div className="page-container">
                <div></div>
                <div className="impact-statement">
                    <div>
                    <div className="impact-title">Programming</div>
                    <div className="impact-description">Creativity combined with logic.</div>
                    </div>
                </div>
                <div className="footer">
                    <div className="footer-line"></div>
                </div>
            </div>
        </>
    )
}